import {Card, CardBody, CardSubtitle, CardTitle} from "reactstrap";
import React from "react";
import usePermissions from "../../../hooks/usePermissions";

interface CardCrmSystemProps {
    id: number;
    name: string;
    onUpdate?: (id: number) => void
    onDelete?: (id: number) => void
}

const CardCrmSystem: React.FC<CardCrmSystemProps> = ({id, name, onUpdate, onDelete}) => {
    const [wantRemove, setWantRemove] = React.useState(false);

    const {hasPermission} = usePermissions();

    const updateClickHandle = () => {
        if (onUpdate) onUpdate(id);
    }

    const removeClickHandle = () => {
        setWantRemove(true);
    }

    const removeAcceptClickHandle = () => {
        if (onDelete) onDelete(id);
    }

    return (
        <Card className="text-center">
            <CardBody>
                <CardSubtitle className="mb-2 text-muted" tag="span">
                    System Name
                </CardSubtitle>
                <CardTitle className="font-size-20 fw-bold" tag="h4">
                    {name}
                </CardTitle>
            </CardBody>

            <div className="btn-group" role="group">
                {hasPermission("update-crm-system") && (
                    <button
                        type="button"
                        className="btn btn-outline-light text-truncate"
                        title="Assign"
                        onClick={() => updateClickHandle()}
                    >
                        <i className="mdi mdi-pencil-outline font-size-14"/>
                    </button>
                )}

                {hasPermission("delete-crm-system") && (
                    wantRemove ? <button
                        type="button"
                        className="btn btn-danger text-truncate"
                        title="Info"
                        onClick={() => removeAcceptClickHandle()}
                    >
                        <i className="mdi mdi-check-bold font-size-14"/>
                    </button> : <button
                        type="button"
                        className="btn btn-outline-light text-truncate"
                        title="Info"
                        onClick={() => removeClickHandle()}
                    >
                        <i className="mdi mdi-delete font-size-14"/>
                    </button>
                )}
            </div>
        </Card>
    )
}

export default CardCrmSystem;